<template src="./template.html"></template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { isEmpty, pickBy } from 'lodash'
  import SingleSelectInput from '@/components/ui/SingleSelectInput'

  export default {
    name: 'SearchFilter',
    components: {
      SingleSelectInput,
    },
    data() {
      return {
        filters: {},
      }
    },
    computed: {
      ...mapState('jobs', ['filterOptions']),
    },
    created() {
      this.$store.subscribe(mutation => {
        if (mutation.type === 'jobs/RESET_FILTER') {
          this.onResetFilter()
        } else {
          return false
        }
      })
      if (isEmpty(this.filterOptions)) {
        this.getJobsFilters()
      }
    },
    methods: {
      ...mapActions('jobs', [
        'resetFilter',
        'getJobsFilters',
        'updateFilters',
      ]),
      onResetFilter() {
        this.filters = {}
        this.$emit('onResetFilter')
      },
      onResultUpdate(id, args) {
        this.$set(this.filters, id, args)
        this.updateFilters(pickBy(this.filters))
        this.$emit('filter')
      },
    },
  }
</script>
